"use client";import createIcon from'./util/createIcon';export default createIcon('M7,10L12,15L17,10H7Z','MenuDown');